import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './edi.actions.js';
import getters from './edi.getters.js';
import mutations from './edi.mutations.js';
import state from './edi.state.js';

BaseStore.registerModule('transmissions', {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
});
export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('transmissions');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
